import { setupPlausible } from '../../components/plausible';
window.up.compiler('.js-post_share', function (shareButton) {
    var _a;
    if (shareButton instanceof HTMLButtonElement) {
        const shareUrl = shareButton.dataset.shareUrl;
        const shareTitle = shareButton.dataset.shareTitle;
        const shareData = { title: shareTitle, url: shareUrl };
        const canShare = typeof navigator.canShare === 'function' && navigator.canShare(shareData) && typeof navigator.share === 'function';
        if (canShare && shareUrl) {
            const { trackEvent } = setupPlausible();
            const eventName = shareButton.dataset.trackShareEventName || '';
            const props = (shareButton.dataset.trackShareProps && JSON.parse(shareButton.dataset.trackShareProps)) || {};
            const dropdownShareButton = (_a = shareButton === null || shareButton === void 0 ? void 0 : shareButton.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.js-post_share_dropdown_menu');
            if (dropdownShareButton) {
                dropdownShareButton.style.display = 'none';
            }
            shareButton.style.display = '';
            shareButton.addEventListener('click', () => {
                navigator
                    .share(shareData)
                    .then(() => {
                    trackEvent(eventName, { props });
                })
                    .catch(error => {
                    console.warn('Sharing failed or cancelled', error); // eslint-disable-line no-console
                });
            });
        }
    }
});
